<template>
<div class="contentBox messageListPage">
    <div class="messagesHeader">
        <h1>系统消息</h1>
        <div class="searchBox">
            <input type="text" class="search" @focus="focusInput" @blur="inputBlur" @keyup.enter="searchMessage" v-model="searchKey" />
            <div :class="[searchFocus ? 'focus' : '', 'searchBtn']" @click="searchMessage"></div>
        </div>
    </div>
    <div class="messageListWrap">
        <el-table :data="messages" border style="width: 100%" header-row-class-name="tableHeader" class="messageTable" @expand-change="checkMessage">
            <el-table-column label="时间" align="left">
                <template slot-scope="scope">
                    <el-badge is-dot class="item" v-if="!scope.row.checked">{{ scope.row.sendTime }}</el-badge>
                    <span v-else>{{ scope.row.sendTime }}</span>
                </template>
            </el-table-column>
            <el-table-column type="expand">
                <template slot-scope="scope">
                    <p>{{ scope.row.content }}</p>
                </template>
            </el-table-column>
            <el-table-column prop="title" label="标题" width="930"></el-table-column>
        </el-table>
    </div>

    <div class="paginationBox" v-if="pageCount > 1">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="[15, 30, 50, 100]" :page-size="pageSize" layout="prev, pager, next" :total="totalCount" prev-text="上一页" next-text="下一页"></el-pagination>
    </div>
</div>
</template>

<script>
    import common from '../../../common.vue';
    import moment from 'moment';
    import 'moment/locale/zh-cn';

    export default {
        name: "Message",
        data() {
            return {
                searchKey: '',
                searchFocus: false,
                pageIndex: 1,
                pageSize: 20,
                totalCount: 0,
                pageCount: 0,
                messages: []
            };
        },
        methods: {
            focusInput() {
                this.searchFocus = true;
            },
            inputBlur() {
                this.searchFocus = false;
            },
            handleSizeChange(val) {
                this.pageSize = val;
                this.loadMessage(this.pageIndex);
            },
            handleCurrentChange(val) {
                this.loadMessage(val);
            },
            searchMessage(){
                this.loadMessage(1);
            },
            loadMessage(pageIndex) {
                let _this = this, index = pageIndex || 1, messages = [];
                _this.$axios.post(common._BASE_ + 'message/list',
                    this.$qs.stringify({pageNo: index, pageSize: _this.pageSize, searchKey: _this.searchKey})).then(function (res) {
                    let r = res.data;
                    _this.pageIndex = index;
                    if (r && r.messages) {
                        (r.messages || []).forEach(function(msg){
                            msg.sendTime = moment(msg.sendTime).format('YYYY-MM-DD hh:mm');
                            messages.push(msg);
                        });
                        _this.messages = messages;

                    }
                    _this.totalCount = r.count;
                    _this.pageCount = Math.ceil(r.count / _this.pageSize);
                });
            },
            checkMessage(row){
                console.info(row);
                let _this = this;
                _this.$axios.post(common._BASE_ + 'message/check',
                    this.$qs.stringify({messageId: row.messageId})).then(function (res) {
                    let r = res.data;
                    if (r && r.code === 0) {
                        for(let i=0; i<_this.messages.length; i++){
                            let msg = _this.messages[i];
                            if(msg.messageId === row.messageId){
                                msg.checked = true;
                                break;
                            }
                        }
                    }
                });
            }
        },

        mounted() {
            this.loadMessage(1);
        },
    };
</script> 

<style lang="less">
.messageListPage {
    .messagesHeader {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 20px;

        h1 {
            height: 20px;
            line-height: 24px;
            font-size: 20px;
            font-weight: bold;
            color: #221816;
        }

        .searchBox {
            position: relative;

            .search {
                width: 437px;
                height: 40px;
                border: solid 1px #e8e8e8;
                background: #fff;
                border-radius: 6px;
                padding-left: 12px;
            }

            .search:focus {
                border: 1px solid #306ff6;
            }

            img {
                position: absolute;
                right: 13px;
                top: 12px;
                cursor: pointer;
            }
        }
    }

    // .messageListWrap {
    //     height: 860px;
    // }

    .delectIcon {
        width: 12px;
        height: 13px;
        background: url("../../../assets/delete-gray.svg") 0 0 no-repeat;
        cursor: pointer;
        display: block;
        margin: 0 auto;
    }

    .delectIcon:hover {
        width: 12px;
        height: 13px;
        background: url("../../../assets/delete-blue.svg") 0 0 no-repeat;
        cursor: pointer;
        display: block;
        margin: 0 auto;
    }

    tbody p{
        margin: 8px 20px 8px 20px;
    }

    .messageTable{
        td{
            height: 30px;
            line-height: 30px;
        }
    }
    .el-table div.cell {
        overflow: visible;
    }
}
</style>